import type { Cache } from '@urql/exchange-graphcache'

function invalidateCache(cache: Cache, fields: string | Array<string>): void {
    const innerFields = Array.isArray(fields) ? fields : [fields]
    cache
        .inspectFields('Query')
        .filter((field) => innerFields.includes(field.fieldName))
        .forEach((field) => {
            cache.invalidate('Query', field.fieldName, field.arguments)
        })
}

export { invalidateCache }
